const manhourSectionsConsumptionServiceName = "/ManagementReport";
const managementReportControllerSecondServiceName = "/ManagementReportSecond";
const missionVacationServiceName = "/MissionVacation";

export function reportService(http) {
    return {   
        manhourSectionsConsumptionPagedAsync: (dateFrom, dateTo, disciplineCode,pageIndex,pageSize,sortBy,filters) => {
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DisciplineCode: disciplineCode,
                RequestAttribute: {
                    Page: pageIndex,
                    PageSize: pageSize,
                    Sorts: newSortBy,
                    Filter: filters
                }
            }
            return http.post(manhourSectionsConsumptionServiceName + "/ManhourSectionsConsumptionPagedServiceAsync", parameterContainer)
        },
        manhourSectionsConsumptionAsync: (dateFrom, dateTo, disciplineCode) => {
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DisciplineCode: disciplineCode
            }
            return http.post(manhourSectionsConsumptionServiceName + "/ManhourSectionsConsumptionServiceAsync", parameterContainer)
        },
        personnelDisciplineDateFilteringAsync: (personnelCode, disciplineCode, dateFrom, dateTo ) => {
            var parameterContainer = {
                personnelCode: personnelCode,
                dateFrom: dateFrom,
                dateTo: dateTo,
                dicsiplineCode: disciplineCode
            };
            
            return http.post(manhourSectionsConsumptionServiceName + "/GetPersonnelDisciplineDateFilteringAsync", parameterContainer)
        },
        getPersonnelDisciplineDateType2FilteringPagedAsync: (disciplineCode, dateFrom, dateTo,pageIndex,pageSize,sortBy,filters ) => {
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DisciplineCode: disciplineCode,
                RequestAttribute: {
                    Page: pageIndex,
                    PageSize: pageSize,
                    Sorts: newSortBy,
                    Filter: filters
                }
            };
            return http.post(manhourSectionsConsumptionServiceName + "/GetPersonnelDisciplineDateType2FilteringPagedAsync", parameterContainer)
        },
        getPersonnelDisciplineDateType2FilteringAsync: (disciplineCode, dateFrom, dateTo ) => {
             var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DicsiplineCode: disciplineCode
            };
            return http.post(manhourSectionsConsumptionServiceName + "/GetPersonnelDisciplineDateType2FilteringAsync", parameterContainer)
        },        
        personnelDisciplineDateActivityFilteringAsync: (personnelCode, disciplineCode, dateFrom, dateTo ) => {
            var parameterContainer = {
                personnelCode: personnelCode,
                dateFrom: dateFrom,
                dateTo: dateTo,
                dicsiplineCode: disciplineCode
            };
            
            return http.post(manhourSectionsConsumptionServiceName + "/GetPersonnelDisciplineDateActivityFilteringAsync", parameterContainer)
        },
        getDiscilpineDateCostCenterAsync: (disciplineCode, dateFrom, dateTo, costCenterCode ) => {
            var parameterContainer = {
                costCenterCode: costCenterCode,
                dateFrom: dateFrom,
                dateTo: dateTo,
                dicsiplineCode: disciplineCode
            };
            
            return http.post(manhourSectionsConsumptionServiceName + "/GetDiscilpineDateCostCenterAsync", parameterContainer)
        },
        getDisciplineDateFilterPlusCostCenterAndActivityPagedAsync: (disciplineCode, dateFrom, dateTo,pageIndex,pageSize,sortBy,filters) => {
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DisciplineCode: disciplineCode,
                RequestAttribute: {
                    Page: pageIndex,
                    PageSize: pageSize,
                    Sorts: newSortBy,
                    Filter: filters
                }
            };
            return http.post(managementReportControllerSecondServiceName + "/GetDisciplineDateFilterPlusCostCenterAndActivityPagedAsync", parameterContainer)

        },
        getDisciplineDateFilterPlusCostCenterAndActivityAsync: (disciplineCode, dateFrom, dateTo) => {            
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DicsiplineCode: disciplineCode
            };
            return http.post(managementReportControllerSecondServiceName + "/GetDisciplineDateFilterPlusCostCenterAndActivityAsync", parameterContainer)

        },
        getDisciplineDateFilterWithGroupPagedAsync: (disciplineCode, dateFrom, dateTo,pageIndex,pageSize,sortBy,filters) => {            
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DisciplineCode: disciplineCode,
                RequestAttribute: {
                    Page: pageIndex,
                    PageSize: pageSize,
                    Sorts: newSortBy,
                    Filter: filters
                }
            };

            return http.post(managementReportControllerSecondServiceName + "/GetDisciplineDateFilterWithGroupPagedAsync", parameterContainer)

        },
        getDisciplineDateFilterWithGroupAsync: (disciplineCode, dateFrom, dateTo) => {        
            var parameterContainer = {
                dateFrom: dateFrom,
                dateTo: dateTo,
                DicsiplineCode: disciplineCode
            };
            return http.post(managementReportControllerSecondServiceName + "/GetDisciplineDateFilterWithGroupAsync", parameterContainer)

        },
        getManHourSummaryAsync: (personnelCode, year, month) => {    
            var parameterContainer = {
                personnelCode,
                year,
                month
            };
            return http.post(missionVacationServiceName + "/GetManHourSummaryAsync", parameterContainer)
        }
        
    }
}